const details = [
  {
    id: 1,
    name: "SigmaCare Hospital",
    img: "https://i.ibb.co/1nyQhvn/project.png",
    img1: "https://i.ibb.co/B604VDN/db.png",
    img2: "https://i.ibb.co/6W2H9cd/ca.png",
    img3: "https://i.ibb.co/DYTjVZM/bb.png",
    description:
      "It is a Hospital Management website. Here patient can find their best services and best output from our doctors and staff.",
    clientCode: "https://github.com/lukmanhossain/SigmaCare-Client",
    serverCode: "https://github.com/lukmanhossain/SigmaCare-Server",
    liveSite: "https://sigmacare-hospital.netlify.app/",
  },
  {
    id: 2,
    name: "Blood Bank",
    img: "https://i.ibb.co/C9jG3rr/b1.png",
    img1: "https://i.ibb.co/kxCMHMT/b2.png",
    img2: "https://i.ibb.co/1vmnyrt/b3.png",
    img3: "https://i.ibb.co/LnJH8SS/b4.png",
    description:
      "It is a Blood Bank website. Here donar can donet blood and anyone can take blood as blood-group quantity or request for blood if anyone needed.",
    clientCode: "https://github.com/lukmanhossain/blood-bank-client",
    serverCode: "https://github.com/lukmanhossain/blood-bank-client",
    liveSite: "https://blood-bank-1d1c3.web.app/",
  },
  {
    id: 3,
    name: "Travel Agency",
    img: "https://i.ibb.co/Bq9BMtn/t1.png",
    img1: "https://i.ibb.co/NTj3krd/t2.png",
    img2: "https://i.ibb.co/WH7FzY3/t3.png",
    img3: "https://i.ibb.co/wr0wpCh/t4.png",
    description:
      "It is a Travels Agency website. Where travellers can share their experiences. Or If anyone want's to travel they can book their services.",
    clientCode:
      "https://github.com/lukmanhossain/programming-hero-task-clientSide",
    serverCode:
      "https://github.com/lukmanhossain/programming-hero-task-clientSide",
    liveSite: "https://munni-travels.web.app/",
  },
  {
    id: 4,
    name: "Pottery Shop",
    img: "https://i.ibb.co/dKFMznH/p1.png",
    img1: "https://i.ibb.co/9GpcGH5/p2.png",
    img2: "https://i.ibb.co/jfxnXSJ/p3.png",
    img3: "https://i.ibb.co/0j8Z085/p4.png",
    description:
      "It is a Pottery Shop website. Where anyone can buy their favourite pottery.",
    clientCode: "https://github.com/lukmanhossain/pottery-client",
    serverCode: "https://github.com/lukmanhossain/pottery-client",
    liveSite: "https://potteryshop.netlify.app/",
  },
  {
    id: 5,
    name: "Programming Youtube Channel",
    img: "https://i.ibb.co/yYLrj8S/pc1.png",
    img1: "https://i.ibb.co/CK8Bz76/pc2.png",
    img2: "https://i.ibb.co/XSZnRv7/pc3.png",
    img3: "https://i.ibb.co/JvrrLfY/pc4.png",
    description:
      "It is a best programming learning youtube channel website. Where anyone can learn programming from Youtube Channel.",
    clientCode: "https://github.com/lukmanhossain/programming-learning-channel",
    serverCode: "https://github.com/lukmanhossain/programming-learning-channel",
    liveSite: "https://programming-learning-channel.netlify.app/",
  },
  {
    id: 6,
    name: "MackBook Pro",
    img: "https://i.ibb.co/QnX5TMT/m1.png",
    img1: "https://i.ibb.co/F5M8mj0/m2.png",
    img2: "https://i.ibb.co/gT9Tpv3/m3.png",
    img3: "https://i.ibb.co/LNF0Cs1/m4.png",
    description:
      "It is a Buy Macbook Pro website. Where anyone can buy Macbook with configuration by their choice. It's a shopping-cart website where use basic js.",
    clientCode:
      "https://github.com/lukmanhossain/macbook-pro-interective-website",
    serverCode:
      "https://github.com/lukmanhossain/macbook-pro-interective-website",
    liveSite: "https://jovial-banach-6dec52.netlify.app/",
  },
];

export default details;
